import { combine, withContext, withCallback } from 'react-hooks-combine'
import { ServicesContext } from 'services/context'
import { toaster } from 'utils/toast-wrapper'
import { admin } from 'routes/route.map'

import TriggerAddComponent from './component'

export const TriggerAdd = combine(
  withContext(
    'adminTriggerService',
    ServicesContext,
    ({ adminTriggerService }) => adminTriggerService
  ),
  withCallback(
    'onSubmit',
    ({ adminTriggerService }, { history }) =>
      async (trigger) => {
        await adminTriggerService.create(trigger)
        toaster.info('Trigger has been successfully created')
        history.push(admin.triggers())
      },
    ['history']
  )
)(TriggerAddComponent)
